import { render, staticRenderFns } from "./TendersFilters.vue?vue&type=template&id=79c80630"
import script from "./TendersFilters.vue?vue&type=script&lang=js"
export * from "./TendersFilters.vue?vue&type=script&lang=js"
import style0 from "./TendersFilters.vue?vue&type=style&index=0&id=79c80630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports